import { SET_COURSEWARE_ITEM } from '../constants/actions';

export default function (id, data) {
  return {
    type: SET_COURSEWARE_ITEM,
    id,
    data,
  };
}
